var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-wrap ga-4",
      attrs: { "data-qa": "case-images" },
    },
    _vm._l(_vm.caseImages, function (caseImage, index) {
      return _c(_setup.CaseImage, {
        key: index,
        attrs: {
          "case-image": caseImage,
          "image-width": 197,
          "image-height": 197,
          index: index,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }